export default "__VITE_ASSET__ZrnQkns7__"